import React from 'react'

import influencerData from '../../data-influencer/get-strong'
import PageBuilder from '../PageBuilder'
import PageLayout from './PageLayout'

const GetStrong = () => (
    <PageBuilder influencerData={influencerData}>
        <PageLayout />
    </PageBuilder>
)

export default GetStrong
